import { staticColors } from '../../const/colors/staticColors';
export const getTagBackgroundColor = (tagColor) => {
    const backgroundColorMap = {
        action: staticColors.tagActionBackground,
        actionLight: staticColors.tagActionLightBackground,
        warning: staticColors.tagWarningBackground,
        warningLight: staticColors.tagWarningLightBackground,
        danger: staticColors.tagDangerBackground,
        dangerLight: staticColors.tagDangerLightBackground,
        grey: staticColors.tagGreyBackground,
        greyLight: staticColors.tagGreyLightBackground,
        success: staticColors.tagSuccessBackground,
        successLight: staticColors.tagSuccessLightBackground,
    };
    return backgroundColorMap[tagColor];
};
export const getTagTextColor = (tagColor) => {
    const textColorMap = {
        action: 'white',
        actionLight: 'action',
        warning: 'white',
        warningLight: 'warning',
        danger: 'white',
        dangerLight: 'danger',
        grey: 'white',
        greyLight: 'dark',
        success: 'white',
        successLight: 'success',
    };
    return textColorMap[tagColor];
};
export const getTagSpacings = (tagSize) => {
    const spacingsMap = {
        small: { spacingVertical: '1/4', spacingHorizontal: '1' },
        medium: { spacingVertical: '1/2', spacingHorizontal: '1' },
    };
    return spacingsMap[tagSize];
};
export const getTagTextVariant = (tagSize) => {
    const variantMap = {
        medium: 's2',
        small: 'b3',
    };
    return variantMap[tagSize];
};
